<template>
    <el-dialog :visible.sync="showTag" width="60%">
        <div class="pl10 pr10">
            <hos_apply_title title="预约信息"></hos_apply_title>
            <el-row class="mt30">
                <el-col :span="8">
                    <span>医院:{{doc.hosName}}</span>
                </el-col>
                <el-col :span="10">
                    <span>科室:{{scheme.deptname}}</span>
                </el-col>
                <el-col :span="6">
                    <span>医生:{{scheme.docname}}</span>
                </el-col>
            </el-row>
            <el-row class="mt20">
                <el-col :span="8">
                    <span>就诊日期:{{scheme.schdate|schdateFilter}} {{scheme.ampm|ampmFilter}}</span>
                </el-col>
                <el-col :span="10">
                    <span>预估就诊时间:{{num.numtime}}</span>
                </el-col>
                <el-col :span="6">
                    <span>支付方式:现场支付</span>
                </el-col>
            </el-row>
            <el-row class="mt20">
                <el-col :span="8">
                    <span>挂号费:￥{{scheme.regfee}}元</span>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <hos_apply_title title="就诊人信息"></hos_apply_title>
            <el-row class="mt30">
                <el-col :span="8">
                    <span>姓名:{{order.patName}}</span>
                </el-col>
                <el-col :span="10">
                    <span>手机号:{{order.patMobile|hiddenStr(3,4,4)}}</span>
                </el-col>
                <el-col :span="6">
                    <span>身份证号:{{order.patIdcard|hiddenStr(6,4,8)}}</span>
                </el-col>
            </el-row>
            <div slot="footer" class="flex aic jcc pb20 pt20 mt50">
                <div class="btton flex aic jcc pointer" @click="hide">取 消</div>
                <div class="btton flex aic jcc ml40 pointer" @click="handler">确定添加</div>
                <!--<el-button type="danger" @click="hide" size="mini">取消</el-button>-->
                <!--<el-button type="primary" @click="handler" size="mini">确定加号</el-button>-->
            </div>
        </div>

        <!--<div class="main">-->
            <!--<div>-->
                <!--<h3 class="fs16">预约信息</h3>-->
                <!--<ul>-->
                    <!--<li>-->
                        <!--<span>医院：</span>-->
                        <!--<span>{{doc.hosName}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>科室：</span>-->
                        <!--<span>{{scheme.deptname}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>医生：</span>-->
                        <!--<span>{{scheme.docname}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>就诊日期：</span>-->
                        <!--<span>{{scheme.schdate|schdateFilter}} {{scheme.ampm|ampmFilter}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>预估就诊时间：</span>-->
                        <!--<span>{{num.numtime}}</span>-->
                        <!--<span class="fs12 color_999">（以医院实际情况为准）</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>支付方式：</span>-->
                        <!--<span>现场支付</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>挂号费：</span>-->
                        <!--<span class="color_red">￥{{scheme.regfee}}元</span>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
            <!--<div class="mt15 pt15" style="border-top: 1px dashed #ccc">-->
                <!--<h3 class="fs16">就诊人信息</h3>-->
                <!--<ul>-->
                    <!--<li>-->
                        <!--<span>姓名：</span>-->
                        <!--<span>{{order.patName}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>身份证：</span>-->
                        <!--<span>{{order.patIdcard|hiddenStr(6,4,8)}}</span>-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<span>手机号：</span>-->
                        <!--<span>{{order.patMobile|hiddenStr(3,4,4)}}</span>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
        <!--</div>-->

    </el-dialog>
</template>
<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";
    .btton{
        width: 137px;
        height: 36px;
        border: 1px solid #3692F9;
        border-radius: 4px;
        &:nth-child(1){
            color: #3692F9;
        }
        &:nth-child(2){
            background: #3692F9;
            color: #ffffff;
        }
    }

    .main {
        margin-top: -30px;
        margin-left: -5px;
        margin-right: -5px;

        ul {
            padding-top: 10px;

            li + li {
                margin-top: 10px
            }
        }
    }
</style>
<script>
  import {systemService} from "../../lib/service/system";
  import {ampmFilter, hiddenStr, schdateFilter} from "../../lib/filters";
  import {timeFormat} from "../../lib/utils";
  import hos_apply_title from "../../components/hos/hos-apply-title"

  export default {
    name: "referral-confirm-dialog",
      components:{hos_apply_title},
    data() {
      return {
        info: {},
        scheme: {},
        order: {},
        num: {},
        showTag: false,
      }
    },
    computed: {
      doc() {
        return this.info.doc || {};
      }
    },
    filters: {schdateFilter, ampmFilter, timeFormat, hiddenStr},
    created() {
    },
    methods: {
      async show(data) {
          console.log('号源')
          console.log(data);
          //numdate
        this.num = data.num;
        this.order = data.order;
        this.scheme = data.scheme;
        this.info = await systemService.docCard(data.docId);
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      },
      handler() {
        this.hide();
        let date = this.num.numdate.substring(0,4) + '-' + this.num.numdate.substring(4,6) + '-' + this.num.numdate.substring(6,8);
        let time = this.num.numtime.split('-')[0];
        this.$emit('submit', '确定加号', {
          acceptDocId: this.doc.id,
          id: this.order.id,
          acceptTime: date + ' ' + time + ':00',
          referralResult: 1,
            num:this.num,
            order:this.order,
            scheme:this.scheme
        });
      }
    },
  }
</script>

